module.exports = __webpack_public_path__ + "img/store-alt.346aa7df.svg";